import React, { useEffect } from 'react';
import Modal from './Modal';
import Button from './Button';
import { QuestionMarkCircleIcon } from './icons';

interface DeleteConfirmModalProps {
    isOpen: boolean;
    onClose: () => void;
    onConfirm: () => void;
    itemCount: number;
}

const DeleteConfirmModal: React.FC<DeleteConfirmModalProps> = ({ isOpen, onClose, onConfirm, itemCount }) => {
    if (!isOpen || itemCount === 0) return null;

    const entryText = itemCount === 1 ? 'the selected entry' : `the ${itemCount} selected entries`;

    useEffect(() => {
        if (!isOpen) return;
        const handleKeyDown = (event: KeyboardEvent) => {
            if (event.key === 'Enter') {
                event.preventDefault();
                onClose();
            }
        };
        document.addEventListener('keydown', handleKeyDown);
        return () => document.removeEventListener('keydown', handleKeyDown);
    }, [isOpen, onClose]);

    return (
        <Modal isOpen={isOpen} onClose={onClose} title="Entry Editor">
            <div className="text-gray-900 dark:text-white flex flex-col items-center text-center py-4">
                <div className="flex flex-col sm:flex-row items-center gap-4">
                     <QuestionMarkCircleIcon className="w-16 h-16 text-blue-400 flex-shrink-0" />
                     <div className="text-center sm:text-left">
                        <p className="text-lg">Are you certain you want to delete {entryText}?</p>
                        <p className="text-yellow-500 dark:text-yellow-400 font-semibold mt-2 uppercase">WARNING: Deleted timecard entries cannot be recovered!</p>
                     </div>
                </div>
                
                <div className="flex justify-center gap-4 mt-8 w-full">
                    <Button 
                        onClick={onClose} 
                        variant="secondary" 
                        className="w-32 focus:ring-2 focus:ring-blue-400 focus:ring-offset-2 focus:ring-offset-white dark:focus:ring-offset-gray-800"
                        autoFocus
                    >
                        Cancel
                    </Button>
                    <Button onClick={onConfirm} variant="danger" className="w-32">
                        Delete
                    </Button>
                </div>
            </div>
        </Modal>
    );
};

export default DeleteConfirmModal;
